// Depois de um deploy, a aba que ficou aberta ainda roda o index.html antigo e pede chunks
// (assets/Pagina-<hash>.js) que o deploy apagou. Recarregar busca o index.html novo.
// Ver docs/deploy-railway.md.

const RELOAD_KEY = "nexusq:chunk-reload-at";
// Uma falha logo depois da recarga automática não recarrega de novo (o arquivo sumiu de verdade,
// e recarregar entraria em loop); passada a janela, o próximo deploy volta a recarregar sozinho.
const RELOAD_WINDOW_MS = 30_000;

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chrome, Edge
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /is not a valid JavaScript MIME type/i, // Safari, quando o servidor devolve o index.html no lugar do chunk
  /Unable to preload CSS/i, // Vite, CSS do chunk
];

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export function canAutoReload(lastReloadAt: string | null, now: number): boolean {
  const last = Number(lastReloadAt);
  return !last || now - last >= RELOAD_WINDOW_MS;
}

let reloadPending = false;

export function willAutoReload(): boolean {
  if (reloadPending) return true;
  try {
    return canAutoReload(sessionStorage.getItem(RELOAD_KEY), Date.now());
  } catch {
    return false;
  }
}

/** Recarrega a página uma vez por janela. Retorna false quando a trava impediu a recarga. */
export function reloadForStaleChunk(): boolean {
  if (reloadPending) return true;
  try {
    if (!canAutoReload(sessionStorage.getItem(RELOAD_KEY), Date.now())) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // Sem sessionStorage não dá para garantir que não entra em loop.
    return false;
  }
  reloadPending = true;
  window.location.reload();
  return true;
}
